/*
 * サブシステム名：
 * 機能名：日報一覧
 * 表示項目カスタマイズSP(滋賀自工)
 */
import D2PRMD0011 from '@/views/PRM/D2PRMD0011.js'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'

import DdDateBox from '@/components/DdDateBox'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'

export default {
  extends: D2PRMD0011,
  name: 'NippoListCustomForSGJSp',
  components: {
    DdDateBox,
    DdIconButtonWithTooltip
  },
  data: () => ({
    conditionDetails: [
      { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: null, type: 'value', delete: false, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'tokuisakiId', name: '荷主', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'jomuinJininId', name: '乗務員', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'sharyoId', name: '車両', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstsharyo' },
      { key: 'meisaiHeadFlg', name: '先頭の受注のみ表示', value: null, type: 'checkbox', delete: true, showValue: false, convertValue: false }
    ],
    custoMizeHeaders: [
      { text: '運行実績No', value: 'unkoJissekiNo' },
      { text: '運行日', value: 'unkoYmdDisp' },
      { text: '自動車表示名', value: 'jidoshaHyojiNm' },
      { text: '乗務員', value: 'jomuinJininNmSei' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '商品', value: 'hinmeiDisp' }
    ]
  }),
  computed: {
    custoMizeFilteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.unkoYmdDisp = elem.unkoYmd ? filter.dateFormatter(elem.unkoYmd) : ''
        elem.hacchakuNm = !elem.hatsuchiNm && !elem.hatsuchiBiko && !elem.chakuchiNm && !elem.chakuchiBiko
          ? '' : (elem.hatsuchiCd ? elem.hatsuchiNm : elem.hatsuchiBiko) + ' ⇒ ' + (elem.chakuchiCd ? elem.chakuchiNm : elem.chakuchiBiko)
        return elem
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.unkoJissekiNo > b.unkoJissekiNo) { return 1 }
        if (a.unkoJissekiNo === b.unkoJissekiNo) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return 1 }
        if (a.unkoYmd === b.unkoYmd) { return 0 }
        return -1
      })
    }
  },
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 運行日
    'conditions.unkoYoteiStartYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    },
    'conditions.unkoYoteiEndYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    }
  },
  methods: {
    getNextTransition: function () {
      const nextTransition = 1
      return nextTransition
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.selected = []
      this.page = 1
      this.conditions.unkoYoteiEndYmdString = this.conditions.unkoYoteiStartYmdString
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            meisaiHeadFlg: self.conditions.meisaiHeadFlg
          }
        }
      }
      this.search(opt)
    },
    initBindVariables: function () {
      const initConditions = {
        unkoYoteiStartYmdString: date.getCurrentDate(),
        unkoYoteiEndYmdString: date.getCurrentDate(),
        haishaEigyoshoId: indexeddb.getRecordByCd(this.currentKaishaCode, this.filteredEigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id,
        jomuinJininId: this.userId,
        tokuisakiId: null,
        ninushiId: null,
        juchuEigyoshoId: null,
        haishaTantoJininId: null,
        sharyoId: null,
        hacchusakiId: null,
        sharyoGroup1: null,
        sharyoGroup2: null,
        jissekiTorokuKbn: '03',
        jissekiKakuninKbn: '03',
        haishaStatusKbn: '03',
        haishasakiKbn: '01',
        meisaiHeadFlg: false
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.unkoYoteiStartYmdString.slice(-5),
        haishaEigyoshoNm: indexeddb.getRecord(this.filteredEigyoshoList, initConditions.haishaEigyoshoId).eigyoshoNm,
        tokuisakiNm: '',
        yoshasakiNm: '',
        jomuinJininNm: '',
        jidoshaHyojiNm: '',
        juchuEigyoshoNm: ''
      }
      this.searchText = ''
      this.rows = []
      this.page = 1
    }
  }
}
